import merge from 'lodash/merge';
import {Types} from './actions';
import {Types as ResourceActions} from "../../resources/actions";
import initialState, {makeDefaultChallengeParams} from './initialState';
import ReducerBuilder from "classes/ReducerBuilder";
import {isNoU} from "../../utils/DBUtils";
import {Types as UserActionTypes} from "../Login/actions";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.SUBMIT_CREATE_CHALLENGE)
    .reduce((state, action) => {
        state.createChallengeFormSubmitted = true;
    })
    .forType(Types.UPDATE_CHALLENGE_PARAMS)
    .reduce((state, action) => {
        state.challengeParams = merge({}, state.challengeParams, action.change);
    })
    .forType(Types.CREATE_CHALLENGE_COMPLETE)
    .reduce((state, {challengeId}) => {
        // reset booleans
        state.createChallengeFormSubmitted = false;
        state.creatingChallenge = false;
        state.error = null;

        // reset form data
        state.challengeParams = initialState.challengeParams;

        state.createdChallengeId = challengeId;
    })
    .forType(Types.START_CREATE_CHALLENGE)
    .reduce((state, action) => {
        state.creatingChallenge = true;
        state.createdChallengeId = null;

    })
    .forType(Types.END_CREATE_CHALLENGE)
    .reduce((state, action) => {
        state.creatingChallenge = false;
        state.createdChallengeId = null;
        state.error = null;
    })
    .forType(Types.ERROR_CREATING_CHALLENGE)
    .reduce((state, action) => {
        state.error = action.error;
    })
    .forType(UserActionTypes.LOGOUT_SUCCESS)
    .reduce((state, action) => {
        state.challengeParams = makeDefaultChallengeParams();
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/BreakCreator/reducer.js